import { fromJS } from 'immutable';

import { LOGOUT } from 'app/redux/modules/auth';

const ENDPOINT = '/api/activity';

const LIST_INIT = 'activity/LIST_INIT';
const LIST_SUCCESS = 'activity/LIST_SUCCESS';
const LIST_FAILED = 'activity/LIST_FAILED';

const initialState = {
  list: fromJS([]),
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST_INIT:
      return {
        ...state,
        loading: true
      };

    case LIST_SUCCESS:
      return {
        ...state,
        list: fromJS(action.payload),
        loading: false
      };

    case LIST_FAILED:
      return {
        ...state,
        list: fromJS([]),
        loading: false
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
}

export function fetchActivity() {
  return {
    types: [LIST_INIT, LIST_SUCCESS, LIST_FAILED],
    promise: client =>
      client.get(`${ENDPOINT}/`).then(({ status, results }) => {
        if (status !== 'OK') {
          throw new Error('Fetch request failed');
        }
        return results;
      })
  };
}
